var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2913_25226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 18.5C5.56369 18.5 2.65369 12.5 2.54244 12.2237C2.48748 12.0616 2.48748 11.8859 2.54244 11.7237C2.65369 11.5 5.56369 5.5 11.9999 5.5C18.4362 5.5 21.3462 11.5 21.4574 11.7762C21.5124 11.9384 21.5124 12.1141 21.4574 12.2762C21.3462 12.5 18.4362 18.5 11.9999 18.5Z",
    stroke: "#6D6F81",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5C11.0771 15.496 10.1934 15.1261 9.54282 14.4713C8.89228 13.8166 8.52805 12.9305 8.53004 12.0075C8.53202 11.0846 8.90007 10.2001 9.55341 9.54811C10.2068 8.89617 11.092 8.53003 12.015 8.53003C12.938 8.53003 13.8233 8.89617 14.4766 9.54811C15.13 10.2001 15.498 11.0846 15.5 12.0075C15.502 12.9305 15.1378 13.8166 14.4872 14.4713C13.8367 15.1261 12.953 15.496 12.03 15.5H12Z",
    stroke: "#6D6F81",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2913_25226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show-password.08854546bf6474dc99a15e021245529d.svg";
export { ForwardRef as ReactComponent };